<template lang='pug'>
  blue-layout(:user='user' :account='account' :biz='biz')
    template(v-slot:header)
      blank-header
    template(v-slot:default='props')
      base-modal#rsv-dialog(:show='show.rsv' :scrolled='props.scrolled')
        modal-wrapper(@close='show.rsv = false')
          template(v-slot:header)
            h4 {{ $t('Reservation/Appointment Details') }}
          template(v-slot:contents)
            rsv-dtls.overlay(
              v-if='rsv'
              :options='{ show: { biz: true, cus: false } }'
              :rsv='rsv'
            )
            rsv-msgs(
              v-if='rsv && account'
              :rsv='rsv'
              :account='account'
              :key='rsv.id'
            )
      #welcome.view.no-header
        section#reservations
          bf-wrapper.content.reserve
            .toggles
              bf-button( :class='{ inactive: toggle == "historical" }' @click.native='toggle = "upcomming"' )
                template(v-slot:text) {{ $t('Upcomming') }}
              bf-button( :class='{ inactive: toggle == "upcomming" }' @click.native='toggle = "historical"' )
                template(v-slot:text) {{ $t('Historical') }}
              
              span.info - {{ $t("My reservations info") }}
            
            carousel.reservations-container(
              v-show='toggle == "upcomming"'
              :scrollPerPage='false'
              :paginationEnabled="false"
              :navigationEnabled='true'
              :perPageCustom='[[320, 1], [480, 2], [800, 3], [1200, 4]]'
            )
              slide.slide.no-rsv( v-if='!upcomming.length' )
                base-card.padded
                  .time-count
                    span.time
                      span.icon
                        time-icon
                      span.text {{ `${datetime.getMonth() + 1}/${date}` }}
                  h5 {{ $t('No Activity') }}
                  
              slide.slide( v-for='rsv, i in upcomming' :key='rsv.id' )
                rsv-card(
                  :rsv='rsv'
                  :i='i'
                  :reservations='rsvs'
                  :class='{ inactive: rsv.datetime.start.toDate().getDate() > new Date().getDate() }'
                  @click.native='rsv_details(i)'
                )
            carousel.reservations-container(
              v-show='toggle == "historical"'
              :scrollPerPage='false'
              :paginationEnabled="false"
              :navigationEnabled='true'
              :perPageCustom='[[320, 1], [480, 2], [800, 3], [1200, 4]]'
            )
              slide.slide( v-for='rsv, i in historical' :key='`${"historical"}-${rsv.id}`' )
                rsv-card(
                  :rsv='rsv'
                  :i='i'
                  :reservations='rsvs'
                  :class='{ inactive: rsv.datetime.start.toDate().getDate() > new Date().getDate() }'
                  @click.native='rsv_details(i)'
                )
        
        section#favorites(v-if="favorites.length")
          bf-wrapper.content
            .heading
              h4 {{ $t('Favorite Sellers') }} 
              span.info-b - {{ $t("Select your favorite sellers for products and services")}}
            
            carousel(
              :perPageCustom="[[180, 1], [360, 2], [540, 3], [720, 4], [900, 5]]" 
              :paginationEnabled="false" 
              :navigationEnabled='true'
            )
              slide(v-for='favorite in favorites' :key='favorite.id')
                base-card.fav
                  favorite-card(:favorite='favorite', :account='account')
        section#promos(v-if='!account.merchant')
          bf-wrapper.content
            H4.heading {{$t("Please choose the following options to start BlueFaucet Services")}}
            span.banner
              span.box( @click='$router.push({ name: "upgrade" })')
                img(src='/business-s.png')
                h5.info-t {{$t("Start selling")}}
                span {{$t("Selling something or provide services? Check here to enable the selling function.")}}
              span.box( @click='$router.push({ name: "referrals" })')
                img(src='/referral-s.png')
                h5.info-t {{$t("Referral Program")}}
                span {{$t("Make extra money, check out our Referral Program")}}
              span.box( @click='$router.push({ name: "merchants" })')
                img(src='/favorite-s.png')
                h5.info-t {{$t("My Favorites")}}
                span {{$t("Add your favorite sellers and easily access their pages.")}}
              span.box(v-if="1==0" @click='$router.push({ name: "referrals" })')
                img(src='sales-s.png')
                h5.info-t {{$t("Join our Sales Team")}}
                span {{$t("Join BlueFaucet and grow with us.")}}
            
        section#merchants
          #map( ref='map' )

          bf-wrapper.content
            h4.heading {{ $t("Nearby Sellers")}}
            bf-wrapper.merchantlist
              merchant-card( 
                v-for='item in nearby' 
                :item='item' 
                :key='item.id' 
                :user='user'
              )

        section#coupons(v-if='coupons.length')
          bf-wrapper.content
            h4.heading {{ $t("Special offers from Sellers")}}
            bf-wrapper.couponlist
              coupon-card(v-for='item in coupons' :key='item.id' :item='item' @click.native='$router.push({ name: "merchant", params: {id: item.biz.id}})')
        
        section#promos(v-if='!account.merchant && 0')
          bf-wrapper.content
            router-link.banner( :to='{ name: "upgrade" }')
              h1.centered-text {{ $t("Start Selling") }}
              img(src='/business.png')
              .centered-text.text
                h3 {{ $t("BlueFaucet is beta-testing now") }}
                h3 {{ $t("See how BlueFaucet can grow your business") }}
            
</template>
<script>
  import sort from '@/lib/sorters'
  import { db, firebase, auth } from '@/main'
  import { View } from '@/mixins/view'
  import { Carousel, Slide } from 'vue-carousel'
  import BlankHeader from '@/components/blank-header'
  import BaseCard from '@/components/base-card'
  import RsvCard from '@/components/rsv-card'
  import FavoriteCard from '@/components/favorite-card'
  import BaseModal from '@/components/modals/base'
  import ModalWrapper from '@/components/modals/wrapper'
  import MerchantCard from '@/components/cards/merchant'
  import CouponCard from '@/components/cards/coupon'
  
  export default {
    name: 'welcome.view',
    mixins: [ View ],
    components: {
      BlankHeader,
      BaseCard,
      RsvCard,
      BaseModal,
      ModalWrapper,
      FavoriteCard,
      Carousel,
      Slide,
      MerchantCard,
      CouponCard
    },

    data() {
      return {
        map: null,
        toggle: 'upcomming',
        show: { rsv: false, modal: { srvs: false, csts: false } },
        rsv: {},
        reservations: [],
        names: [
          'BlueFaucet',
          'Furry Friends',
          'Mr. Barber',
          'Site for Paws',
          'Angel Maids',
          'Handman Services',
          'Beauty Salon',
          'Spark Nails',
          'Fresh Dryclean',
          'Caters R Us'
        ],
        month: new Date().getMonth(),
        human: {
          months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
          days: [ 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat' ]
        },
        date: new Date().getDate(),
        merchants: [],
        coupons: [],
        blacklisted: [],
        favs: []
      }
    },

    firestore() {
      if ( auth.currentUser ) {
        return {
          favs: {
            ref: db.collection('favorites').where('account_id', '==', auth.currentUser.uid),
          },

          reservations: {
            ref: db.collection('reservations').where('account_id', '==', auth.currentUser.uid),
          },
          merchants: {
            ref: db.collection( 'businesses' ).orderBy('name').startAfter(''),
            resolve: sort.merchants
          },
          coupons: {
            ref: db.collection('coupons').limit( 3 )
          },
          blacklisted: {
            ref: db.collection( 'customers' ).where( 'category', '==', 'Blacklist' ).where( 'account_id', '==', this.account.id ),
          }
        }
      }
      else {
        return {
          merchants: {
              ref: db.collection( 'businesses' ).orderBy('name').startAfter(''),
              resolve: sort.merchants
            },
          coupons: {
            ref: db.collection('coupons').limit( 3 )
          }
        }
      }
    },

    computed: {
      favorites() {
        return this.filter( this.favs )
      },

      nearby() {
        let merchants = this.merchants.filter( d =>  !this.favorites.map( f => f.business_id ).includes( d.id ) )
        return this.filter( merchants, 'id' ).slice( 0, 3 )
      },

      datetime() {
        let d = new Date()
        d.setHours( 0, 0, 0 )
        d.setMonth( this.month )
        d.setDate( this.date )
        return d
      },
      days() {
        return new Date( this.datetime.getFullYear(), this.month + 1, 0).getDate()
      },
      rsvs() {
        if ( this.toggle == 'upcomming' ) return this.upcomming
        else return this.historical
      },
      upcomming() {
        return this.reservations
        .filter( r =>  r.datetime.start.toDate() > this.datetime )
        .sort( (r1, r2) => r1.datetime.start.toDate() - r2.datetime.start.toDate() )
      },
      historical() {
        return this.reservations
        .filter( r =>  r.datetime.start.toDate() < this.datetime )
        .sort( (r1, r2) => r2.datetime.start.toDate() - r1.datetime.start.toDate() )
      }
    },
    
    watch: {
      account(curr, prev) {
        if ( curr.id ) {
          this.$binding( 'favs', db.collection( 'favorites' ).where( 'account_id', '==', curr.id ) )
          this.$binding( 'blacklisted', db.collection( 'customers' ).where( 'category', '==', 'Blacklist' ).where( 'account_id', '==', this.account.id ) )
          this.$binding( 'reservations', db.collection( 'reservations' ).where( 'account_id', '==', curr.id ) )
        }
      },
    },
    
    methods: {
      filter( docs, field='business_id' ) {
        return docs.filter( doc => !this.blacklisted.map( b => b.business_id ).includes( doc[field] ) )
      },

      rsv_details(i) {
        this.rsv = this.rsvs[i]
        this.show.rsv = true
      }
    },

    mounted() {
      // let geo = new window.google.maps.Geocoder()
      // let address = '92618'
      // geo.geocode( { address }, ( results, status ) => console.log( 'results', results[0].geometry.location.lat() ) )
    }
  }
</script>
<style scoped lang='stylus'>
  #map
    width 333px
    height 0px
  .heading
    background white
    padding 15px 15px
    border-radius 5px
    box-shadow 0 1px 2px #8d949e
    
  .base-card.fav
    height 100%
    box-shadow 0 1px 2px #8d949e
    
  .toggles
    .bf-button:first-child
      margin-right 16px
  #rsv-dialog
    .bf-button
      margin 12px 4px
  .VueCarousel-slide
    padding 5px
    box-sizing border-box
    margin-top 10px
  .VueCarousel-slide.pagenation
    border 1px solid #000000
    background blue
  .title
    font-weight bold
    font-size 1.2em
    padding 10px
    line-height 30px
  .info
    margin-left 15px
    color white
  .info-b
    margin-left 10px
    
  .info-t
    line-height 30px
    color blue
  .box
    border 1px solid lightgray
    box-shadow 0 1px 2px #8d949e
    padding 10px
    border-radius 5px
    background white
    text-align center
    cursor pointer
    &:first-child
      background rgb(240 255 255)
      border 2px solid
    
  #merchants
    background rgb(245 245 245)
    margin-top 0px
    .merchantlist
      display grid
      padding 15px 0px
      grid-template-columns repeat( auto-fill, minmax( 300px, 1fr ) )
      grid-gap 10px
      @media( max-width: 420px )
        grid-template-columns 1fr
        
  #coupons
    background rgb(245 245 245)
    margin-top 0px
    .couponlist
      display grid
      padding 15px 0px
      grid-template-columns repeat( auto-fill, minmax( 200px, 1fr ) )
      grid-gap 10px
      @media( max-width: 420px )
        grid-template-columns repeat( auto-fill, minmax( 150px, 1fr))
        
  #favorites
    background rgb(245 245 245)
    margin-top 0px

    // background-image url("/ui/favorback2.svg")
    // background-repeat no-repeat
    // background-position center
    
  #reservations
    background-color rgb(132 169 241)
    .bf-wrapper.reserve
      background-image url("/ui/monthback3.svg")
      background-repeat no-repeat
      background-position right
    
    .no-rsv
      .time-count
        display flex
        align-items center
        margin-bottom 10px
        .text
          font-weight bold
        .time
          .icon
            margin-right 10px
        .count
          margin-left auto
      h5
        // font-size .88em
      .base-card
        padding 12px
        height 100%
        box-sizing border-box
    .month
      font-weight bold
      color black
      text-align center
      margin-bottom 4px
      position relative
      .prev, .next
        vertical-align middle
        font-size 2.4em
      .current
        padding 0 12px
      .today
        position absolute
        left 0
        top 3px
    .days-container
      margin-bottom 24px
      .slide
        text-align center
        .day
          background rgb( 245 245 245 )
          border-radius 5px
          padding 12px
          margin 12px 4px
          transition all 320ms
          font-size .88em
          &.active
            background var(--clr-blue)
            color white
            transform translateY(-12px)
          .date
            margin-bottom 4px
            font-weight bold
  #promos
    background rgb(245 245 245)
    margin-top 0px
    padding 20px
    .bf-wrapper.content
      padding-top 4px
      padding-bottom 4px
      @media(max-width: 640px)
        font-size .92em
        .promo-text
          width 320px
      @media(max-width: 480px)
        .promo-text
          width 200px
          h1
            font-size 1.75em
            margin 16px 0
    
    .banner
      display grid
      grid-template-columns 1fr 1fr 1fr
      margin-top 10px
      grid-gap 10px
      @media( max-width: 480px )
        grid-template-columns 1fr
        grid-gap 10px
      h1
        font-weight bold
        color var(--clr-blue)
        font-size 2.75em
        border-top 4px solid var(--clr-dark)
        border-bottom 4px solid var(--clr-dark)
        padding 24px 0
      img
        height 100px
        margin 0 auto
      .centered-text
        margin auto
        &.text
          line-height 1.5
  .bf-modal
    a
      display block
      margin-top 24px
      margin-bottom 48px
  .rsv-dtls
    margin 24px auto
</style>
